import { render } from "./ManageVendors.vue?vue&type=template&id=02afd128&scoped=true"
import script from "./ManageVendors.vue?vue&type=script&lang=js"
export * from "./ManageVendors.vue?vue&type=script&lang=js"

import "./ManageVendors.vue?vue&type=style&index=0&id=02afd128&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02afd128"]])

export default __exports__